module.exports = __webpack_public_path__ + "static/media/BG_PDJ_Recruitment.bb4f9cf0.jpg";